import { create } from 'zustand';
import type { User } from '../types';

interface AuthState {
  user: User | null;
  token: string | null;
  isAuthenticated: boolean;
  login: (token: string, user: User) => void;
  logout: () => void;
}

const TOKEN_KEY = 'lessoncraft_token';
const USER_KEY = 'lessoncraft_user';

const storedToken = localStorage.getItem(TOKEN_KEY);
const storedUserRaw = localStorage.getItem(USER_KEY);
let storedUser: User | null = null;
if (storedUserRaw) {
  try {
    storedUser = JSON.parse(storedUserRaw) as User;
  } catch {
    storedUser = null;
  }
}

export const useAuthStore = create<AuthState>((set) => ({
  user: storedUser,
  token: storedToken,
  isAuthenticated: !!(storedToken && storedUser),

  login: (token: string, user: User) => {
    localStorage.setItem(TOKEN_KEY, token);
    localStorage.setItem(USER_KEY, JSON.stringify(user));
    set({ token, user, isAuthenticated: true });
  },

  logout: () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
    set({ token: null, user: null, isAuthenticated: false });
    window.location.href = '/login';
  },
}));
